<template>
    <div v-loading="loading" style="min-height: 100vh" element-loading-spinner="el-icon-loading">
        <div class="store_detail_page" v-if="!loading">
            <div class="sh_page_padding ">
                <!--標題-->
                <div class="page_top">
                    <div class="title" @click="back()">
                        <i class="icon" id="icon"></i>
                        <span class="header-text">{{ product.name }}</span>
                    </div>
                </div>
                <div>
                    <!--輪播圖片-->
                    <div class="block">
                        <el-carousel arrow="always" :autoplay="false" height="300px" v-if="product!=''">
                            <el-carousel-item v-for="i in JSON.parse(product.imgsUrl)" :key="i">
                                <div class="w-100 d-flex justify-content-center h-100 ">
                                    <img class=" h-100" :src="i" alt="" @error="imgError">
                                </div>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                    <!--商品敘述-->
                    <div class="text-block bg-white shadow p-2">

                        <div class="pt-3 bg-white ">
                            <span class="fw-bold main-color" style="font-size: 20px">{{ product.name }}</span>
                        </div>
                        <div style="font-size: 14px">
                            <el-tag type="danger" effect="dark" v-if="product.isPreorder==1" class="me-2 mt-2"
                                    size="mini">預購
                            </el-tag>
                            <span class="fw-bold " v-if="product.shipDate >0">保證{{ product.shipDate }}天內發貨</span>
                        </div>
                        <div class="mt-1 d-flex justify-content- align-items-center">
                            <span class="me-2 plain-text" style="font-size: 14px">網路價</span>
                            <div style="font-family: Helvetica">
                                <span style="font-size: 20px;color: #d0011b;"
                                      class="fw-bold">${{ product.salePrice.toLocaleString() }}</span>
                                <span class="ms-2 plain-text text-decoration-line-through">${{
                                        product.originalPrice.toLocaleString()
                                    }}</span>
                            </div>
                            <div>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between mt-1">
                            <div class="d-flex flex-column" style="font-size: 14px">
                                <div v-if="product.isFreeDelivery==1">
                                    滿<span class="fw-bold" style="font-family: Helvetica"> {{
                                        product.freeDelivery.toLocaleString()
                                    }} </span>免運費
                                </div>
                                <span class="fw-bold" v-if="product.isFreeDelivery==0" style="font-family: Helvetica">運費:{{
                                        product.deliveryFee
                                    }}</span>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between">
                            <div style="font-size: 14px" class="secondary-text">
                                可購買數量:<span v-if="product.amount>0"
                                                 style="font-family: Helvetica">{{ product.amount }}</span>
                                <span v-if="product.amount == 0" class="text-danger">已售完</span>
                            </div>
                            <span class="secondary-text"
                                  style="font-size: 14px">最後上線時間：{{ getPostDate(product.lastOnline) }}</span>
                        </div>


                        <el-divider>商品敘述</el-divider>
                        <div class="description " v-html="product.description"></div>
                        <el-divider>商品圖片</el-divider>
                        <!--商品圖片-->
                        <div v-if="product!=''">
                            <img v-for="i in JSON.parse(product.imgsUrl)" :key="i" class="w-100" :src="i" alt=""
                                 @error="imgError">
                        </div>
                        <!--商品注意事項-->
                        <el-divider>商品注意事項</el-divider>
                        <div v-if="product!=''">
                            <div class="description" v-html="product.notice"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div class="action-block">
                    <div class="mx-3 d-flex fs-1 text-secondary">
                        <el-badge :value="this.$root.shoppingCarCount" class="item me-4">
                            <i class="fas fa-shopping-cart" @click="goToCar"></i>
                        </el-badge>
                        <i class="fas fa-comments" @click="getChatroomInfo"></i>
                    </div>
                    <el-button class="btn add-car-btn" type="primary" @click="showAddCar" :disabled="maxNum==0">
                        加入購物車
                    </el-button>
                    <el-button class="btn" type="danger" @click="showBuyNow" :disabled="maxNum==0">直接購買</el-button>
                </div>
            </div>

        </div>
        <!--回到頂端-->
        <el-backtop v-if="!loading" target=".sh_page_padding" :visibility-height="500" :bottom="150" :right="25"/>
        <!--加入購物車-->
        <div class="shopping-car-block">
            <el-drawer :visible.sync="this.shoppingCarDrawer" :direction="direction" size="50%" :before-close="close"
                       :show-close="true" >
                <div class="d-flex flex-column h-100">
                    <div class="row mx-1 info-block">
                        <img v-if="product!=''" :src="JSON.parse(product.imgsUrl)[0]" alt="" class="w-50 col-6"
                             @error="imgError">
                        <div class="col-6">
                            <div class="d-flex flex-column align-content-end h-100 ">
                                <div class="mt-2">
                                    <span class="main-color fw-bold" style="font-size: 18px"> {{ product.name }}</span>
                                </div>
                                <div class="mt-auto d-flex justify-content-start align-items-end">
                                    <span class="me-2 plain-text" style="font-size: 16px"> 網路價</span>
                                    <span class="me-2 price"> {{ product.salePrice }}</span>
                                    <span class="original_price secondary-text"> {{ product.originalPrice }}</span>

                                </div>
                                <div class="mt-2">
                                    <el-input-number v-model="form.number" :min="1" :max="maxNum"></el-input-number>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center mt-auto px-2 mb-2">
                        <el-button v-if="drawerBtnType==1" class="btn add-car-btn w-100 mt-2" id="add-car-btn"  @click="addCar"
                                   :disabled="maxNum==0">加入購物車
                        </el-button>
                        <el-button v-if="drawerBtnType==2" class="btn w-100 mt-2" type="danger" @click="buyNow"
                                   :disabled="maxNum==0">直接購買
                        </el-button>
                    </div>
                </div>
            </el-drawer>
        </div>
        <el-dialog :visible.sync="dialogVisible" width="70%" :before-close="handleClose">
            <span>{{ dialogMessage }}</span>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleClose">確定</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<style>
.original_price {
    font-family: Helvetica;
    font-size: 16px;
    text-decoration: line-through;

}

.el-loading-spinner .el-icon-loading {
    font-size: 1.5rem;
    color: #606266;
}

.main-color {
    color: #303133;

}

.plain-text {
    color: #606266;
}

.secondary-text {
    color: #909399;
}

.el-drawer__header {
    color: #303133;
    font-weight: bold;
    font-size: 18px;
}

#add-car-btn:focus {
    border-color: #409eff;
    background: #409eff;
    color: white;
}
#add-car-btn{
    border-color: #409eff;
    background: #409eff;
    color: white;
}
</style>
<script>

import FN from '@/components/fn'
import {GET_CHATROOM_INFO} from "@/api";

export default {
    mixins: [FN],
    data() {
        return {
            count: 10,
            direction: 'btt',
            drawer: true,
            maxNum: 0,
            product: "",
            id: "",
            loading: true,
            shoppingCarDrawer: false,
            form: {
                number: 1,
                productId: "",
                type: 1,
                checked: 1,
            },
            // shoppingCarCount: 0,
            drawerBtnType: '1', //1.加入購物車 2.直接購買
            dialogVisible: false,
            dialogMessage: "",
        }
    },
    mounted() {
        this.id = this.$route.params.id
        this.getProduct();
        this.getShoppingCarCount();

    },
    methods: {
        getProduct() {
            this.FETCH({
                key: 'GET_PRODUCT_DETAIL',
                id: this.id,
            }).then((res) => {
                //需要accToken的驗證
                if (+(res || {}).code === -3) {
                    this.checkNewToken(this.getProduct)
                } else if (+(res || {}).code === 1) {
                    this.dialogVisible = true;
                    this.dialogMessage = '沒有該商品資訊。';
                } else if (+(res || {}).code === 0) {
                    this.product = res.data;
                    this.form.productId = res.data.id;
                    this.maxNum = res.data.amount;
                    this.loading = false;
                } else {
                    this.dialogVisible = true;
                    this.dialogMessage = '取得商品資訊失敗，請稍後重試。';
                }


            })
        },
        back() {
            // this.$router.push(-1)
            this.$router.push({name: 'Store'})

        },
        showAddCar() {
            this.drawerBtnType = 1;
            this.shoppingCarDrawer = true;
        },
        goToCar() {
            this.$router.push({name: 'StoreCar'})
        },
        close() {
            this.shoppingCarDrawer = false;
        },
        buyNow() {
            this.drawerBtnType = 2;
            this.shoppingCarDrawer = true;
            this.addCar();
        },
        addCar() {
            this.FETCH({
                key: 'MODIFY_SHOPPING_CAR',
                ...this.form
            }).then((res) => {
                if (+(res || {}).code === -3) {
                    this.checkNewToken(this.addCar);
                } else if (res.code == 0) {
                    this.shoppingCarCount = res.data.count;
                    this.$message({
                        message: '已加入購物車',
                        type: 'success'
                    });
                    this.getShoppingCarCount();
                    if (this.drawerBtnType == 2) {
                        this.goToCar();
                    }
                } else {
                    this.$message({
                        message: res.message,
                        type: 'error'
                    });
                }
            });
            this.shoppingCarDrawer = false;

        },
        getShoppingCarCount() {
            this.FETCH({
                key: 'GET_SHOPPING_CAR_COUNT',
            }).then((res) => {
                if (+(res || {}).code === -3) {
                    this.checkNewToken(this.getShoppingCarCount);
                }
                this.$root.shoppingCarCount=res.data.count;
            })
        },
        imgError(event) {
            event.target.src = require('@/assets/img_error.svg');
        },
        showBuyNow() {
            this.drawerBtnType = 2;
            this.shoppingCarDrawer = true;
        },
        handleClose() {
            this.dialogVisible = false;
            this.back();
        },
        getChatroomInfo(){
            this.loading=true;
            this.FETCH({
                key: 'GET_CHATROOM_INFO',
                productId:this.id,
            }).then((res) => {
                if (+(res || {}).code === -3) {
                    this.checkNewToken(this.getChatroomInfo);
                }
                if (+(res || {}).code === 0) {
                    let channelId = res.data.channelId;
                    let channle = res.data.channle;
                    let showName = res.data.showName;
                    this.$router.push({name: "StoreChatroom",params:{id:channelId,channel:channle,showName:showName}});

                }else {
                    console.log(res);
                    this.$message('網路不穩，請稍後重試。');
                }
                this.loading=false;
            })
        }
    }
}
</script>



